/*
 * Copyright 2026 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const GITFLIC_READ_SCOPES = [
  'USER_READ',
  'PROJECT_READ',
  'TEAM_READ',
  'COMPANY_READ',
  'REPOSITORY_READ',
];

export const GITFLIC_WRITE_SCOPES = [
  'USER_WRITE',
  'PROJECT_WRITE',
  'PROJECT_EDIT',
  'TEAM_WRITE',
  'COMPANY_WRITE',
  'REPOSITORY_WRITE',
];
